import React from 'react';
import MaterialIcon, {colorPalette} from 'material-icons-react'

export const getIcon = (iconName, size, color) => (
  <MaterialIcon icon={iconName} color={color ? color : colorPalette.grey._900} size={size ? size : 24} />
)